// extracted by mini-css-extract-plugin
module.exports = {"section":"index-module--section--2H7AH","grid":"index-module--grid--1H0zl"};